export default __webpack_public_path__ + "static/823-7890428ff8f83b19eebb8b22dad2bc90.gif";